(function () {
  'use strict';

  angular
      .module('tfc.Nav',
      [
        'ui.router'
      ])
      .config(config);

  // @ngInject
  function config($stateProvider, $httpProvider) {

    // Interceptor to extract the X-Application-Version header
    $httpProvider.interceptors.push('AppVersion');

    $stateProvider
        .state('page', {
          abstract : true,
          template : '<tfc-page full-width=":: false"></tfc-page>'
        })
        .state('widePage', {
          abstract : true,
          template : '<tfc-page full-width=":: true"></tfc-page>'
        })
    ;
  }

})();
